import React from "react";
import MembershipRetentionRateReportView from "../../features/MetabaseDashboard/MembershipRetentionRateReportView";

const MembershipRetentionRateReport = () => {
  return (
    <div>
      <MembershipRetentionRateReportView />
    </div>
  );
};

export default MembershipRetentionRateReport;
